import { useEffect, useMemo } from "react";
import { Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useGetUserByIdQuery, useLazyGetOrganizationDetailsQuery } from "../../../redux/reducers/apiSlice";
import { NotificationResponse as Notification } from "../../../redux/reducers/types";
import { truncate } from "../../utils/helper";
import useScreenType from "react-screentype-hook";


const NotificationMessage = ({ notification, setIsOpenAcceptInviteModal }: { notification: Notification, setIsOpenAcceptInviteModal: (param: boolean) => void }) => {

    const { data: user, isLoading: isLoadingUser } = useGetUserByIdQuery(notification.userId);
    const [getOrganization, { data: org, isLoading: isLoadingOrg }] = useLazyGetOrganizationDetailsQuery();
    const { isMobile } = useScreenType();

    const userFullName = useMemo(() => {
        if(user){
            return `${user.name.firstName} ${user.name.lastName}`
        }
        return '';
    },[user])

    useEffect(() => {

        if(notification.data.orgId){
            getOrganization(notification.data.orgId);
        }

    },[notification.data.orgId])


    const collapseNames = (message: string) => {

        let messageCopy = message; 
        
        if(messageCopy.includes(userFullName)){
            const noSpaceFullName = userFullName.split(" ").join("");
            messageCopy = messageCopy.replace(userFullName, noSpaceFullName);
        }

        if(org?.name && messageCopy.includes(org?.name)){
            const noSpaceOrgName = org.name.split(" ").join("");
            messageCopy =  messageCopy.replace(org.name, noSpaceOrgName);
        }
        return messageCopy;
    }

    if(isLoadingOrg || isLoadingUser) return <p>Loading...</p>

    return <div className="message">
         {collapseNames(notification.message).split(" ").map((word) => {

            const noSpaceFullName = userFullName.split(" ").join("");
            const noSpaceOrgName = org?.name.split(" ").join("");

            if(word === "post" && notification.data.postId){
                return <Link to={`/posts/${notification.data.postId}`} style={{ fontWeight: 'bold' }}>
                    post{" "}
                </Link>
            } 

            if(word === noSpaceFullName && notification.userId){
                return <Link to={`/users/${notification.userId}`} style={{ fontWeight: 'bold' }}>
                         {truncate(userFullName, 30, 15)}{" "}
                    </Link>
            }

            if(word === noSpaceOrgName && notification.data.orgId){
                return <Link to={`/organizations/${notification.data.orgId}`} style={{ fontWeight: 'bold' }}>
                        {truncate(org?.name, 30, 15)}{" "}
                    </Link>
            }

            
            return `${word} `
        })}
        {isMobile && notification?.message.toLowerCase().includes("invited you to join") && (
        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
          <Button onClick={() => setIsOpenAcceptInviteModal(true)} style={{backgroundColor: 'transparent', color: 'rgb(238,90,41)'}}>
            View invitation
          </Button>
        </div>
        )}
    </div>

}

export default NotificationMessage;